module.exports = __webpack_public_path__ + "static/img/icon_case_2.bdfb6fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_case_2.png
// module id = wpjQ
// module chunks = 0